import axiosInstance from "../utils/axios";
import { URL } from "../utils/axios";

const API_URL = `${URL}/api/super-admin`;

// ===== COMMUNITY ENDPOINTS =====
export const fetchAllCommunities = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/communities`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchCommunityById = async (communityId) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/communities/${communityId}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createCommunity = async (communityData) => {
  try {
    const response = await axiosInstance.post(
      `${API_URL}/communities`,
      communityData
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCommunity = async (communityId, communityData) => {
  try {
    const response = await axiosInstance.put(
      `${API_URL}/communities/${communityId}`,
      communityData
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ===== RCR PROJECT MANAGER ENDPOINTS =====
export const addRCRProjectManager = async (managerData) => {
  try {
    const response = await axiosInstance.post(
      `${API_URL}/rcr-project-managers`,
      managerData
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchRCRProjectManagersByCommunit = async (communityId) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/rcr-project-managers/community/${communityId}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createUser = async (userData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/users`, userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ===== USER MANAGEMENT ENDPOINTS =====
export const fetchAllUsersGlobal = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/users`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchUsersByCommunity = async (communityId) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/users/community/${communityId}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateUserRole = async (userId, role) => {
  try {
    const response = await axiosInstance.put(
      `${API_URL}/users/${userId}/role`,
      { role }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteUserGlobal = async (userId) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/users/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ===== PROPERTY MANAGEMENT ENDPOINTS =====
export const fetchAllPropertiesGlobal = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/properties`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchPropertiesByCommunity = async (communityId) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/properties/community/${communityId}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ===== DASHBOARD ENDPOINTS =====
export const fetchDashboardStats = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/dashboard/stats`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
